/**
 * 时间转换
 * @param dateToFormat
 * @returns {*}
 */
export function formatDate(dateToFormat) {
  let format = "暂无日期";
  if (dateToFormat) {
    let time = new Date(dateToFormat);
    let mo = time.getMonth() + 1,
      d = time.getDate(),
      h = time.getHours(),
      mi = time.getMinutes();

    format = `${mo}月${d}日 ${h}:${mi < 10 ? "0" + mi : mi}`;
  }

  return format;
}

/**
 * 时间转换2
 * @param dateToFormat
 * @returns {*}
 */
export function formatDate2(dateToFormat) {
  let time = new Date(dateToFormat);
  let mo = time.getMonth() + 1,
    d = time.getDate(),
    h = time.getHours(),
    mi = time.getMinutes(),
    s = time.getSeconds();

  let format = `${mo}/${d} ${h}:${mi < 10 ? "0" + mi : mi}:${
    s < 10 ? "0" + s : s
  }`;
  return format;
}

//年月日时分秒
export function formatDate3(dateToFormat) {
  if (!dateToFormat) {
    return "暂无日期";
  }
  
  let time = new Date(dateToFormat);
  
  // Check if the date is valid
  if (isNaN(time.getTime())) {
    return "暂无日期";
  }
  
  let Y = time.getFullYear();
  let M =
    time.getMonth() + 1 - 0 >= 10
      ? Number(time.getMonth()) + 1
      : "0" + (Number(time.getMonth()) + 1);
  let D = time.getDate();
  let h = time.getHours() >= 10 ? time.getHours() : "0" + time.getHours();
  let m = time.getMinutes() >= 10 ? time.getMinutes() : "0" + time.getMinutes();
  let s = time.getSeconds() >= 10 ? time.getSeconds() : "0" + time.getSeconds();
  return Y + "-" + M + "-" + D + " " + h + ":" + m + ":" + s;
}

// 图片json字符串转数组取第一张图片
export function getImgsOne(imgs) {
  if (imgs) {
    return JSON.parse(imgs)[0];
  } else {
    return "";
  }
}

// 密码中等判断,6~10位的数字+字母；字母+特殊字符，特殊字符+数字
export function passwordVerification(password) {
  let reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,20}$/;
  // console.log(password, reg.test(password)); // true
  return reg.test(password);
}


export function getUrlParam(param) {
  // 获取由全部参数组成的字符串。
  let query = window.location.search.substring(1);
  // 分割参数，得到每一个参数字符串组成的数组。
  let vars = query.split('&');
  // 遍历数组，得到每一个参数字符串。
  for (let i = 0; i < vars.length; i++) {
      // 分割每一个参数字符串，得到参数名和参数值组成的数组。
      var pair = vars[i].split('=');
      // 如果参数名等于传入的param，则返回该值。
      if (pair[0] == param) {
          return decodeURI(pair[1]);
      }
  }
  // 若参数不存在，则返回false。
  return false;
}

/**
 * 详情/表单中的币种文案：优先 foreignType，其次指定 *Unit 字段，默认人民币(CNY)
 * @param {object} data 挂牌或成交对象
 * @param {string} [unitField] 如 floorPriceUnit、transferFloorPriceUnit
 * @param {string} [secondUnitField] 第二顺位单位字段（如 stockPriceUnit）
 */
export function formatCurrencyUnitLabel(data, unitField, secondUnitField) {
  if (!data || typeof data !== "object") return "人民币(CNY)";
  if (data.foreignType != null && String(data.foreignType).trim() !== "") {
    return String(data.foreignType).trim();
  }
  if (
    unitField &&
    data[unitField] != null &&
    String(data[unitField]).trim() !== ""
  ) {
    return String(data[unitField]).trim();
  }
  if (
    secondUnitField &&
    data[secondUnitField] != null &&
    String(data[secondUnitField]).trim() !== ""
  ) {
    return String(data[secondUnitField]).trim();
  }
  return "人民币(CNY)";
}

/**
 * 卡片、列表、详情页价格前的货币前缀（返回英文大写币种代码）
 */
export function priceCurrencyPrefix(foreignTypeOrUnit) {
  const raw =
    foreignTypeOrUnit == null ? "" : String(foreignTypeOrUnit).trim();
  if (!raw) return "CNY";
  const lower = raw.toLowerCase();
  if (raw.includes("美元") || lower.includes("usd")) return "USD";
  if (raw.includes("欧元") || lower.includes("eur")) return "EUR";
  if (raw.includes("英镑") || lower.includes("gbp")) return "GBP";
  if (raw.includes("日元") || lower.includes("jpy")) return "JPY";
  if (raw.includes("港币") || lower.includes("hkd")) return "HKD";
  if (raw.includes("新台币") || lower.includes("twd") || lower.includes("ntd")) return "TWD";
  if (raw.includes("人民币") || lower.includes("cny")) return "CNY";
  return "CNY";
}

/**
 * 挂牌金额展示兜底：
 * 优先 floorPrice；为空时按业务类型回退到对应业务金额字段。
 */
export function getListingDisplayPrice(data) {
  if (!data || typeof data !== "object") return null;
  const hasValue = (v) =>
    v !== undefined && v !== null && String(v).trim() !== "";
  if (hasValue(data.floorPrice)) return data.floorPrice;

  const dealWay = data.dealWay == null ? "" : String(data.dealWay);
  if (dealWay.indexOf("转让") !== -1 && hasValue(data.transferFloorPrice)) {
    return data.transferFloorPrice;
  }
  if (dealWay.indexOf("许可") !== -1 && hasValue(data.licenseFloorPrice)) {
    return data.licenseFloorPrice;
  }
  if (dealWay.indexOf("作价入股") !== -1 && hasValue(data.stockFloorPrice)) {
    return data.stockFloorPrice;
  }

  if (hasValue(data.transferFloorPrice)) return data.transferFloorPrice;
  if (hasValue(data.licenseFloorPrice)) return data.licenseFloorPrice;
  if (hasValue(data.stockFloorPrice)) return data.stockFloorPrice;
  return null;
}

/**
 * 产权类型请求传参映射：
 * - 界面「版权」→ 后端「作品」
 * - 界面「其他」→ 后端「植物新品种,地理标志,数据,其他」
 */
export function mapPropertyCategoryForRequest(value) {
  if (value == null || value === "") return value;
  const CATEGORY_REQUEST_MAP = {
    版权: "作品",
    其他: "植物新品种,地理标志,数据,其他",
  };
  const mapToken = (token) => CATEGORY_REQUEST_MAP[token] || token;
  const tokens = Array.isArray(value)
    ? value.map((item) => String(item).trim())
    : String(value).split(",").map((s) => s.trim());
  return tokens
    .filter((s) => s !== "")
    .map(mapToken)
    .join(",");
}
